import PropTypes from 'prop-types'
import React from 'react'
import Header from '../../components/Header/Header'
import TrackNav from "../../components/TrackNav/TrackNav"
import '../../styles/ClientStyles.scss'
import './css/ClientLayout.scss'

export const ClientLayout = ({ body: Body }) => (
  <div className="client-viewport-layout">
    <div className="client-fixed-block">
      <Header />
      <TrackNav />
    </div>
    <Body />
  </div>
)

ClientLayout.propTypes = {
  body: PropTypes.any
}

export default ClientLayout



// WEBPACK FOOTER //
// ./src/layouts/ClientLayout/ClientLayout.js